import { render, staticRenderFns } from "./MergeCatalogDialog.vue?vue&type=template&id=3b6f0bc2&"
import script from "./MergeCatalogDialog.vue?vue&type=script&lang=js&"
export * from "./MergeCatalogDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports